import axios from 'axios';
import config from '../config';

export default (itemIds) => {
  const url = `${config.dynamicGalleryApiUrl}?${itemIds.map(x => `items=${encodeURIComponent(x)}`).join('&')}`;

  return axios.get(url)
    .then((response) => response);
};
